import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

const InstallPWAButton = () => {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [isInstallable, setIsInstallable] = useState(false);
const {t}=useTranslation();
  useEffect(() => {
    // Listen for the beforeinstallprompt event
    const handleBeforeInstallPrompt = (e) => {
      e.preventDefault();
      // Save the event to trigger the install prompt later
      setDeferredPrompt(e);
      setIsInstallable(true);
    };

    window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);

    return () => {
      window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
    };
  }, []);

  const handleInstallClick = () => {
    if (deferredPrompt) {
      deferredPrompt.prompt();  // Show the install prompt
      deferredPrompt.userChoice.then((choiceResult) => {
        if (choiceResult.outcome === 'accepted') {
          console.log('User accepted the install prompt');
        } else {
          console.log('User dismissed the install prompt');
        }
        setDeferredPrompt(null);  // Clear the saved prompt
      });
    }
  };

  return (
    <>
      {isInstallable && (
// Minimal version - replace your button with this

<div className="bg-gradient-to-r from-blue-50 to-orange-50 border border-gray-200 rounded-lg p-4 my-4">
  <div className="flex items-center justify-between space-x-3">
    <div className="flex items-center space-x-3">
      <div className="w-10 h-10 bg-white rounded-lg shadow-sm flex items-center justify-center">
        <svg className="w-5 h-5 text-orange-500" fill="currentColor" viewBox="0 0 20 20">
          <path fillRule="evenodd" d="M3 4a1 1 0 011-1h12a1 1 0 011 1v2a1 1 0 01-1 1H4a1 1 0 01-1-1V4zm0 4a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H4a1 1 0 01-1-1V8zm8 0a1 1 0 011-1h4a1 1 0 011 1v2a1 1 0 01-1 1h-4a1 1 0 01-1-1V8z" clipRule="evenodd" />
        </svg>
      </div>
      
      <div>
        <h4 className="font-medium text-gray-900 text-sm">Add to Home Screen</h4>
        <p className="text-xs text-gray-600">Get quick access and offline features</p>
      </div>
    </div>
    
    <div className="flex items-center space-x-2">
      <button 
        className="inline-flex items-center px-3 py-1.5 bg-white border border-orange-300 text-orange-600 text-sm font-medium rounded-md hover:bg-orange-50 transition-colors duration-200"
        onClick={handleInstallClick}
      >
        <svg className="w-3 h-3 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8l-8-8-8 8" />
        </svg>
        Install
      </button>
      
      <button className="p-1 text-gray-400 hover:text-gray-600">
        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
    </div>
  </div>
</div>
      )}
    </>
  );
};

export default InstallPWAButton;
